export default __webpack_public_path__ + "static/media/adicionales.b065ee47.png";